// extracted by mini-css-extract-plugin
export default {"progress":"potok-fm_progress__ZUPuJ"};